import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { COMPLETE_BOOKING_GOLF, COMPLETE_BOOKING_GOLF_SUCCESS, COMPLETE_BOOKING_GOLF_ERROR } from '../../../actions.js';

function* completeBookingGolf({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/complete-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: COMPLETE_BOOKING_GOLF_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: COMPLETE_BOOKING_GOLF_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: COMPLETE_BOOKING_GOLF_ERROR, payload: error });
  }
}

export function* watchCompleteBookingGolf() {
  yield takeEvery(COMPLETE_BOOKING_GOLF, completeBookingGolf);
}

function* completeBookingGolfSaga() {
  yield all([fork(watchCompleteBookingGolf)]);
}

export default completeBookingGolfSaga;
